import React from 'react';

import { MonitorOutlined, PhoneIphoneOutlined } from '@mui/icons-material';
import { Paper, Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import { useCurrentSidebarTab, usePreviewMode } from '@wp-block-builder/editor/hooks';

import EditModeGroup from './EditModeGroup';
import NavigationTreeButton from './NavigationTreeButton';

type Props = {
  subject: JsxNode;
  preheader: JsxNode;
};
export default function SubjectBar({ subject, preheader }: Props) {
  const [previewMode, setPreviewMode] = usePreviewMode();

  const onPreviewChange = (ev: React.MouseEvent, value: unknown) => {
    ev.stopPropagation();
    switch (value) {
      case 'DESKTOP':
        setPreviewMode('DESKTOP');
        break;
      case 'MOBILE':
        setPreviewMode('MOBILE');
        break;
    }
  };

  const [, setCurrentSidebarTab] = useCurrentSidebarTab();
  const onClick = () => {
    setCurrentSidebarTab('GENERAL');
  };

  return (
    <Paper sx={{ py: 0.75, px: 3, zIndex: zIndex.appBar, position: 'relative' }} onClick={onClick}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Stack spacing={1} direction="row" width="100%" alignItems="baseline" minWidth="0">
          <Typography noWrap>{subject}</Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {preheader}
          </Typography>
        </Stack>

        <EditModeGroup />

        <ToggleButtonGroup value={previewMode} exclusive onChange={onPreviewChange} size="small">
          <ToggleButton value="DESKTOP">
            <Tooltip title="Desktop view">
              <MonitorOutlined fontSize="small" />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value="MOBILE">
            <Tooltip title="Mobile view">
              <PhoneIphoneOutlined fontSize="small" />
            </Tooltip>
          </ToggleButton>
        </ToggleButtonGroup>

        <NavigationTreeButton />
      </Stack>
    </Paper>
  );
}
